import type { TError, TLessonProgressBase } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../../axios';
import { ENTITY } from '../entity';

/**
 * Query key for fetching user's progress on a lesson - non-hook version
 */
export const getProgressQueryKey = (lessonId: string) => [ENTITY, 'progress', lessonId];

/**
 * Query key for fetching user's progress on a lesson
 */
export const useGetProgressQueryKey = (lessonId: string) => getProgressQueryKey(lessonId);

/**
 * Hook to fetch user's progress on a specific lesson
 *
 * @param lessonId - Lesson ID (UUID)
 */
export const useGetProgress = (lessonId: string) => {
  return useQuery<TLessonProgressBase | null, TError>({
    queryKey: useGetProgressQueryKey(lessonId),
    queryFn: async () => {
      const res = await axios.get<TLessonProgressBase>(`/community-hub/lessons/${lessonId}/progress`);
      return res.data;
    },
    enabled: !!lessonId,
    staleTime: 60 * 1000, // 1 minute (progress changes frequently)
  });
};
